<template lang="pug">
BriqRadio(
  data-test-id="two-segments-mix-options"
  label="Resource segmentation"
  description="Choose if this resource can be shared among segments or is exclusive for the chosen segments"
  :hide-optional-marker="true"
  :options="options"
  v-model="segmentationOptionSelected"
  :disabled="disabled"
)
</template>

<script>
export default {
  name: 'TwoSegmentsMixOptions',
  props: {
    value: { type: Boolean, default: true },
    disabled: Boolean,
    totalSelectedActiveSegments: Number,
  },
  data() {
    return {
      options: {
        pooled: 'Pooled (all segments use the same settings and can be mixed in a timeslot)',
        perSegment: 'Per segment (every segment has its own settings)',
      },
    }
  },
  computed: {
    segmentationOptionSelected: {
      get() {
        return this.value ? 'pooled' : 'perSegment'
      },
      set(v) {
        this.$emit('input', v === 'pooled')
      },
    },
  },
}
</script>
